export const handleRetakeStartAssessment = (e, url: URL) => {
  e.preventDefault();

  const win = window.open(url, "_self");
  win.focus();
};
